module.exports = __webpack_public_path__ + "static/media/6.f021fe00.jpg";